/**
 * PhotoIcon - Icon representing photos/images
 * Line-based camera icon
 */

import type { IconProps } from './IconTypes';

export function PhotoIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Photo',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Camera body */}
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      {/* Camera lens */}
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}
